












































































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import { Cancelable } from 'lodash'
import axios from 'axios'
import debounce from 'lodash/debounce'
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock'

import VueLoading from './Loading.vue'
import TextInput from './TextInput.vue'
import DateInput from './DateInput.vue'
import CheckboxesInput from './CheckboxesInput.vue'
import RadioInput from './RadioInput.vue'

import {
  Category,
  getPercentComplete,
  filterConditional,
} from '../data/application'

@Component({
  components: {
    VueLoading,
    TextInput,
    DateInput,
    CheckboxesInput,
    RadioInput,
  },
})
export default class GenericForm extends Vue {
  @Prop({ type: String, default: 'Application form' })
  title!: string

  @Prop({ type: Object, default: () => ({}) })
  questions!: Record<string, Category>

  @Prop({ type: Object, default: () => ({}) })
  value!: Record<string, string>

  @Prop({ type: Boolean, default: false })
  allowSubmission!: boolean

  @Prop({ type: Boolean, default: false })
  submitted!: boolean

  @Prop({ type: Object, default: null })
  savedAnswers!: Record<string, string>

  ready = true
  submitting = false

  answerProxy = new Proxy(this.value, {})

  async submit() {
    this.submitting = true
    try {
      const response = await axios.post('/apply', {
        application: this.value,
        profile: this.savedAnswers,
      })
      if (response.data.message === 'success') this.$emit('submitted')
      else
        this.error = new Error(
          'There was a problem submitting your application.',
        )
    } catch (e) {
      this.error = new Error('There was a problem submitting your application.')
    }
    this.submitting = false
  }

  created() {
    const vm = this
    this.answerProxy = new Proxy(vm.value, {
      get: (target, prop, receiver) => target[prop as string],
      set: (target, prop, value, receiver) => {
        vm.$emit('input', { [prop]: value })
        Vue.set(target, prop as string, value as string)
        return true
      },
    })
  }

  @Watch('submitting')
  onOverlayChange(value: boolean) {
    if (!document.documentElement) return
    if (value) {
      document.documentElement.style.overflow = 'hidden'
      disableBodyScroll(document.documentElement, {
        reserveScrollBarGap: true,
      })
    } else {
      document.documentElement.style.overflow = 'visible'
      enableBodyScroll(document.documentElement)
    }
  }

  get percentComplete() {
    return getPercentComplete(this.form, this.value)
  }

  trans(name: string) {
    return {
      name: this.$style[name],
      'enter-class': this.$style[`${name}-enter`],
      'enter-active-class': this.$style[`${name}-enter-active`],
      'enter-to-class': this.$style[`${name}-enter-to`],
      'leave-class': this.$style[`${name}-leave`],
      'leave-active-class': this.$style[`${name}-leave-active`],
      'leave-to-class': this.$style[`${name}-leave-to`],
    }
  }

  get form() {
    const form = {} as Record<string, Category>
    Object.keys(this.questions).forEach(category => {
      const categoryQuestions = this.questions[category]
      if (
        !categoryQuestions.if ||
        categoryQuestions.if({ ...this.value, ...this.savedAnswers })
      ) {
        form[category] = {
          ...categoryQuestions,
          questions: this.filterQuestions(categoryQuestions.questions),
        }
      }
    })
    return form
  }

  filterQuestions<
    T extends { if?: (questions: Record<string, string>) => boolean }
  >(category: Record<string, T>) {
    return Object.keys(category).reduce((filteredObject, item) => {
      const question = category[item]
      if (filterConditional(question, { ...this.value, ...this.savedAnswers }))
        filteredObject[item] = question
      return filteredObject
    }, {} as Record<string, T>)
  }
}
